import { REGEX } from "../../../../constants/index"
import { ValidatePhone } from "../../../../hooks"

export const ValidateText = (value) => {
	return !!(value.length > 0 && REGEX.text.test(value))
}

export const ValidateNumber = (value) => {
	return !!(value.length > 0 && REGEX.number.test(value))
}

export const ValidateEmail = (value) => {
	return !!(value.length > 0 && REGEX.email.test(value))
}

export const ValidatePhoneNumber = (value) => {
	return !!(
		value.length > 0 &&
		REGEX.phone.test(value) &&
		ValidatePhone(value, 10)
	);
}

export const ValidateDate = (value) => {
	return !isNaN(new Date(value).getTime())
}

export const ValidateSelect = (value) => {
	return value && value.length > 0
}

export const ValidateCheck = (value) => {
	return value
}

export const ValidateAll = (type, value) => {

	
	switch (type) {
		case "text":
			return ValidateText(value)
		case "email":
			return ValidateEmail(value)
		case "select":
			return ValidateSelect(value)
		case "select-one":
			return ValidateText(value)
		case "date":
			return ValidateDate(value)
		case "phone":
			return ValidatePhoneNumber(value)
		case "check":
			return ValidateCheck(value)
		case "number":
			return ValidateNumber(value)
		case "radio":
			return ValidateCheck(value)
		case "colonia":
			return ValidateNumber(value)
	}
}
